export default __webpack_public_path__ + "static/DSC_0158-69c681ea18aed2ec1f78a3fa9bf43f79.jpg";